import { Outlet } from "react-router-dom";
import Container from "./Container";
// import Text from "./Text";
// import Image from "./Image";
// import {
//   amazonMusicIcon,
//   appleMusicIcon,
//   deezerIcon,
//   maskGroupIcon,
//   musicxmatchIcon,
//   soundCloudIcon,
//   spotifyIcon,
//   tidalIcon,
// } from "@/assets";

const OnboardingRoutesOutlet = () => {
  return (
    <Container indention={0} cornerRadius={0} hFull wFull flexDisplay>
      <Container indention={0} cornerRadius={0} flexDimension wFull>
        <Outlet />
      </Container>
      {/* <Container
        flexDisplay
        itemsAlign="center"
        contentAlign="center"
        gap={10}
        wFull
        indention={{ top: 10, bottom: 15 }}
      >
        <Text size="xs">
          This registration is gathering your information for the listed
          platforms
        </Text>
        <Container
          flexDisplay
          direction="row"
          itemsAlign="center"
          indention={0}
          gap={10}
        >
          <Image src={soundCloudIcon} />
          <Image src={appleMusicIcon} />
          <Image src={spotifyIcon} />
          <Image src={amazonMusicIcon} />
          <Image src={deezerIcon} />
          <Image src={musicxmatchIcon} />
          <Image src={tidalIcon} />
          <Image src={maskGroupIcon} />
        </Container>
      </Container> */}
    </Container>
  );
};

export default OnboardingRoutesOutlet;
